<template>
  <md-dialog
      :md-active="isVisible"
      :md-backdrop="true"
      class="md-small-size-100"
  >
    <md-dialog-title>View Data</md-dialog-title>

    <md-dialog-content>
      <pre class="bg-gray" v-html="JSON.stringify(data, null, 4)"></pre>
    </md-dialog-content>

    <md-dialog-actions>
      <!-- <md-button class="md-primary" @click="confirm()">Add</md-button> -->
      <md-button class="md-accent" @click="close()">Close</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: 'JsonDataModal',
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.bg-gray {
  background-color: #f7f7f7;
}
</style>
